import { AQSI_RIGHTS } from '../../../shared/model/rights'

/**
 * Кабинет AQSI из «моих ресурсов» Platform (`platformMyResources` с видом `aqsi`): только то, что нужно окну. Список читает
 * binding общим клиентом `platform-ui` — пакет своего клиента `me/resources` не держит (RP-SRC1). Включён ли кабинет и выдано ли
 * право — уже решил сервер: в списке только такие.
 */
export interface AqsiSource {
  id: string
  displayName: string
  /** Ревизия настроек ресурса (`MyResourceDto.configurationVersion`); `null` — сервер не прислал. */
  configurationVersion: string | null
}

/** Аргумент списка кабинетов: право, по которому сервер отбирает ресурсы. */
export interface AqsiSourcesArgs {
  capability: string
}

/**
 * Зачем выбирается кабинет. От цели зависит нужное право: за кассу без
 * `session.open` не сесть, каталог без `catalog.read` не открыть, журнал
 * чеков ККМ без `receipts.read` не прочитать.
 */
export type SourcePurpose = 'rmk' | 'catalog' | 'receipts'

export const PURPOSE_CAPABILITY: Readonly<Record<SourcePurpose, string>> = {
  rmk: AQSI_RIGHTS.sessionOpen,
  catalog: AQSI_RIGHTS.catalogRead,
  receipts: AQSI_RIGHTS.receiptsRead,
}

/** Право продавать (UC1c): без него окно продажи кнопки продажи не даёт. */
export const SALES_CAPABILITY = AQSI_RIGHTS.salesManage

/** Право видеть продажи (`sales.read`): по нему читается список «Требуют внимания» (RP-FB35 K7). */
export const SALES_READ_CAPABILITY = AQSI_RIGHTS.salesRead

/** Право ставить свою цену позиции в чеке (RP-FB8): без него поле цены — только чтение. */
export const PRICE_CAPABILITY = AQSI_RIGHTS.salesPrice

/**
 * Аргументы списков — постоянные объекты: один и тот же аргумент у подписки и
 * у `select`, иначе селектор читал бы чужой ключ кэша.
 */
export const SOURCE_ARGS: Readonly<Record<SourcePurpose | 'sales' | 'salesRead' | 'price', AqsiSourcesArgs>> = {
  rmk: { capability: PURPOSE_CAPABILITY.rmk },
  catalog: { capability: PURPOSE_CAPABILITY.catalog },
  receipts: { capability: PURPOSE_CAPABILITY.receipts },
  sales: { capability: SALES_CAPABILITY },
  salesRead: { capability: SALES_READ_CAPABILITY },
  price: { capability: PRICE_CAPABILITY },
}

/** Подпись источника в окне ресурса: какой кабинет и как он выбран (общий тип окна продажи). */
export type { SourceCaptionVm } from '@krp/sale-ui'
